<template>
    <v-autocomplete
        :value="value"
        @input="$emit('input', $event)"
        :items="tags"
        :loading="loading"
        item-text="name"
        item-value="id"
        return-object
        label="Select Tags"
        multiple
        outlined
        chips
        small-chips
        deletable-chips
        hide-details
        prepend-inner-icon="tag"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tags: [],
            selection: [],
            loading: false,
        };
    },
    methods: {
        getTags() {
            this.loading = true;
            axios.get("/tag").then((response) => {
                this.tags = response.data;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.getTags();
    },
};
</script>

<style></style>
